import React from "react";
import ModalActions from "./ModalActions";
import styles from "./EmployeeList.module.scss";
import { DeleteEmployee, GetEmployeeList } from "../../ApiCalls";

const EmployeeDeleteForm = ({
  employeeName,
  onCancel,
  employeeId,
  setEmployees,
}) => {
  const handleDeleteEmployee = async () => {
    try {
      const result = await DeleteEmployee({ empId: employeeId });
      if (result.data?.success) {
        const employeesResult = await GetEmployeeList();
        setEmployees(employeesResult.data.employeeList);
        onCancel();
      }
    } catch (error) {
      console.error("Failed to delete employee:", error);
    }
  };

  return (
    <div className={styles.modalContent}>
      <p className={styles.deleteText}>Delete {employeeName}</p>
      <ModalActions
        onCancel={onCancel}
        onAction={handleDeleteEmployee}
        actionLabel="Delete"
      />
    </div>
  );
};

export default EmployeeDeleteForm;
